import { render, staticRenderFns } from "./AntStar.vue?vue&type=template&id=623ba407&scoped=true"
import script from "./AntStar.vue?vue&type=script&lang=js"
export * from "./AntStar.vue?vue&type=script&lang=js"
import style0 from "./AntStar.vue?vue&type=style&index=0&id=623ba407&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623ba407",
  null
  
)

export default component.exports